module.exports = __webpack_public_path__ + "static/img/mu_jkfa_icon.png";